"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[959],{

/***/ 63707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31555);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93264);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68019);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50067);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22546);
/* harmony import */ var react_lightgallery__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36822);
/* harmony import */ var lightgallery_js_dist_css_lightgallery_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9733);
/* harmony import */ var lightgallery_js_dist_css_lightgallery_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lightgallery_js_dist_css_lightgallery_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69274);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);

















swiper__WEBPACK_IMPORTED_MODULE_8__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_8__/* .Navigation */ .W_]);

var SliderShowRoom = function SliderShowRoom(_ref) {
  var _getData$section_data, _getData$section_data2, _getData$images, _getData$images2, _getData$images2$list, _getData$images3, _getData$images4, _getData$images4$list, _getData$images5, _getData$images6, _getData$images6$list, _getData$images7, _getData$images7$list;

  var padding = _ref.padding,
      background = _ref.background,
      data = _ref.data;
  var getData = data;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (window.innerWidth > 768) {
      setTimeout(function () {
        var el = document.querySelector('.showroom .swiper-slide-active .testimonial__single__image');
        var elHeight = el === null || el === void 0 ? void 0 : el.clientHeight;
        document.querySelector('.showroom .swiper-initialized').style.height = elHeight + 50 + 'px';
      }, 1200);
    }
  }, [null]);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(100),
      offset = _useState[0],
      setOffset = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setOffset(document.querySelector('.container').offsetLeft);
    window.addEventListener('load', function () {
      setOffset(document.querySelector('.container').offsetLeft);
    });
    window.addEventListener('resize', function () {
      setOffset(document.querySelector('.container').offsetLeft);
    });
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(StyledBox, {
    "data-scroll-container": true,
    offset: offset,
    background: background,
    className: "showroom slider_component ".concat(padding ? padding : 'pt-160 pb-160'),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_lightgallery__WEBPACK_IMPORTED_MODULE_10__/* .LightgalleryProvider */ .rR, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        ref: containerRef,
        className: 'version_one',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            md: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              className: "testimonial__head",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "testimonial__head__text",
                children: (getData === null || getData === void 0 ? void 0 : (_getData$section_data = getData.section_data) === null || _getData$section_data === void 0 ? void 0 : _getData$section_data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_1__["default"], {
                  margin: '0 0 40px 0',
                  text: getData === null || getData === void 0 ? void 0 : (_getData$section_data2 = getData.section_data) === null || _getData$section_data2 === void 0 ? void 0 : _getData$section_data2.title
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "testimonial__head__navigation",
                children: (getData === null || getData === void 0 ? void 0 : (_getData$images = getData.images) === null || _getData$images === void 0 ? void 0 : _getData$images.list) && (getData === null || getData === void 0 ? void 0 : (_getData$images2 = getData.images) === null || _getData$images2 === void 0 ? void 0 : (_getData$images2$list = _getData$images2.list) === null || _getData$images2$list === void 0 ? void 0 : _getData$images2$list.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", {
                    className: "hover",
                    id: 'gallery-prev',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_16__/* .HiArrowSmallLeft */ .d0N, {})
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", {
                    className: "hover",
                    id: 'gallery-next',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_16__/* .HiArrowSmallRight */ .m9E, {})
                  })]
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        fluid: true,
        ref: containerRef,
        className: 'p-0',
        md: 12,
        children: (getData === null || getData === void 0 ? void 0 : (_getData$images3 = getData.images) === null || _getData$images3 === void 0 ? void 0 : _getData$images3.list) && (getData === null || getData === void 0 ? void 0 : (_getData$images4 = getData.images) === null || _getData$images4 === void 0 ? void 0 : (_getData$images4$list = _getData$images4.list) === null || _getData$images4$list === void 0 ? void 0 : _getData$images4$list.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
          slidesPerView: 3,
          spaceBetween: 30,
          speed: "1000",
          navigation: {
            prevEl: '#gallery-prev',
            nextEl: '#gallery-next'
          },
          initialSlide: 2,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false
          },
          loop: true,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          },
          modules: [swiper__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_8__/* .Navigation */ .W_],
          className: "mySwiper",
          children: (getData === null || getData === void 0 ? void 0 : (_getData$images5 = getData.images) === null || _getData$images5 === void 0 ? void 0 : _getData$images5.list) && (getData === null || getData === void 0 ? void 0 : (_getData$images6 = getData.images) === null || _getData$images6 === void 0 ? void 0 : (_getData$images6$list = _getData$images6.list) === null || _getData$images6$list === void 0 ? void 0 : _getData$images6$list.length) > 0 && (getData === null || getData === void 0 ? void 0 : (_getData$images7 = getData.images) === null || _getData$images7 === void 0 ? void 0 : (_getData$images7$list = _getData$images7.list) === null || _getData$images7$list === void 0 ? void 0 : _getData$images7$list.map(function (e, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "testimonial__single",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    sm: 5,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
                      className: "testimonial__single__image video",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .E, {
                        alt: 'Shanta Securities Limited',
                        radius: '21px',
                        src: e === null || e === void 0 ? void 0 : e.full_path
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_lightgallery__WEBPACK_IMPORTED_MODULE_10__/* .LightgalleryItem */ .Sj, {
                        src: e === null || e === void 0 ? void 0 : e.full_path
                      })]
                    })
                  })
                })
              })
            }, index);
          }))
        })
      })]
    })
  });
};

var StyledBox = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CorporateSlider__StyledBox",
  componentId: "sc-1cbee0v-0"
})(["background-color:", ";position:relative;min-height:120vh;.swiper-button-prev,.swiper-button-next{display:none;}.swiper-slide{transition:0.7s all ease;}.swiper-initialized{padding-left:", ";}.testimonial__single{height:100%;.row{height:100%;}}.swiper-slide-active{height:auto;width:50% !important;.testimonial__single__image{width:100%;height:100%;}}.testimonial__head{display:flex;justify-content:space-between;&__text{}&__navigation{ul{display:inline-flex;li{cursor:pointer;height:45px;width:45px;border-radius:25%;overflow:hidden;height:40px;width:40px;background-color:black;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;svg{color:#ffffff;z-index:2;}svg{#Ellipse_605{}#Ellipse_607{}}&:first-child{margin-right:20px;}&:hover{svg{#Ellipse_605,#Ellipse_607{}}}}}}}.testimonial__single{padding:20px 0 0 0;&__image{position:relative;padding-top:calc(312 / 370 * 100%) !important;.react_lightgallery_item{position:absolute;left:0;right:0;top:0;bottom:0;z-index:9;}&__icon{position:absolute;top:-20px;right:-25px;}&__play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);svg{#Ellipse_396,path{transition:0.7s all ease;}}}&.video{cursor:pointer;&:hover{.testimonial__single__image__play{svg{path{fill:white;}#Ellipse_396{rx:31px;ry:31.5px;}}}}}img{}}&__content{.text{color:#32355D;line-height:36px;font-weight:700;}.description{margin:40px 0 40px 0;color:#32355D;}.name{color:#18AEAE;line-height:24px;font-weight:500;}.designation{font-size:12px;line-height:20px;font-weight:500;}}}.col-sm-5,.col-md-6{flex:0 0 100%;max-width:100%;}@media (min-width:768px){}@media (max-width:992px) and (min-width:768px){.swiper-slide-active{height:auto !important;width:inherit !important;.testimonial__single__image{width:100% !important;height:100% !important;}}}@media (max-width:768px){.testimonial__head{flex-direction:column;}.testimonial__single__image__icon{position:absolute;top:-20px;left:0;}.testimonial__single{padding:40px 0 0;&__content{margin-top:20px;.description{margin:20px 0 20px 0;}}}.swiper-initialized{padding-left:60px;padding-right:60px;height:auto !important;}.swiper-slide-active{height:auto;width:inherit !important;.testimonial__single__image{width:100%;height:100%;}}min-height:auto;}"], function (props) {
  return props.background ? props.background : '#FFFFFF';
}, function (props) {
  return props.offset ? props.offset + 15 + 'px' : '100px';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(SliderShowRoom));

/***/ }),

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 98508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      placeholder: "blur",
      objectFit: 'cover',
      layout: 'fill',
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-ncc5rv-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:130%;object-fit:", ";position:absolute;top:-50px;left:0;right:0;bottom:0;will-change:transform;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 37410:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22546);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50067);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33082);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_visibility_sensor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68019);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68312);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93264);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);


















var RandomSliderV1 = function RandomSliderV1(_ref) {
  var Data = _ref.Data,
      padding = _ref.padding;
  // SwiperCore.use([Autoplay]);
  var mLeftRef = useRef();
  var mRightRef = useRef();
  var containerRef = useRef();
  var sliderRef = useRef();

  var _useState = useState(90),
      offset = _useState[0],
      setOffset = _useState[1];

  var _useState2 = useState(0),
      theWidth = _useState2[0],
      SetTheWidth = _useState2[1];

  var _useState3 = useState(1),
      activeNumber = _useState3[0],
      setActiveNumber = _useState3[1];

  var _useState4 = useState(1),
      totalNumber = _useState4[0],
      setTotalNumber = _useState4[1];

  useEffect(function () {
    mLeftRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-prev')) {
        document.querySelector('.swiper-button-prev').click();
      }
    });
    mRightRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-next')) {
        document.querySelector('.swiper-button-next').click();
      }
    });
    setOffset(document.querySelector(' .container').offsetLeft);
  }, []);
  useEffect(function () {
    var _containerRef$current, _document$querySelect, _document$querySelect2;

    setOffset((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetLeft);
    window.addEventListener('resize', function () {
      var _containerRef$current2;

      setOffset((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetLeft);
      SetTheWidth(window.innerWidth);
    }); // slider number

    var getActiveItem = (_document$querySelect = document.querySelector('.swiper-pagination-current')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML;
    var getTotalItem = (_document$querySelect2 = document.querySelector('.swiper-pagination-total')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.innerHTML;
    setActiveNumber(getActiveItem);
    setTotalNumber(getTotalItem);
  }, [Data]);
  useEffect(function () {// document.querySelector('.swiper-container').style.paddingLeft = offset + 'px'
  }, [offset, sliderRef]);
  useEffect(function () {
    if (sliderRef.current) {
      var swiperInstance = sliderRef.current.swiper;

      if (swiperInstance) {
        setTotalNumber(swiperInstance.slides.length);
      }
    }
  }, [Data]);

  var _useState5 = useState(0),
      swiperIndex = _useState5[0],
      setSwiperIndex = _useState5[1];

  var handleSlideChange = function handleSlideChange(swiper) {
    setSwiperIndex(swiper.realIndex);
  };

  useEffect(function () {// var heightblog = document.querySelector('.blog-slider__slider-wrap__inner .blog-single').clientHeight + 115;
    //
    // document.querySelector('.blog-slider').style.transform = 'translateY(' + (-document.querySelector('.blog-single__inner').clientHeight) / 2 + 'px)';
    // document.querySelector('.blog-slider').style.marginBottom = -(document.querySelector('.blog-single__inner').clientHeight) / 2 + 'px';
  });
  var title = 'Life at <span>Shanta</span>';
  return /*#__PURE__*/_jsxs(StyledBlog, {
    offset: offset,
    className: "blog-slider box-slider ".concat(padding ? padding : 'pt-200 pb-200 ', " "),
    children: [/*#__PURE__*/_jsx(Container, {
      ref: containerRef,
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            className: "blog-button",
            children: [/*#__PURE__*/_jsx("div", {
              className: "left",
              children: /*#__PURE__*/_jsx(Title, {
                margin: '0 0 0 0',
                noanim: true,
                text: title
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "d-flex",
              children: Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 1 && /*#__PURE__*/_jsx("div", {
                className: "slider-nav",
                children: /*#__PURE__*/_jsxs("ul", {
                  children: [/*#__PURE__*/_jsx("li", {
                    className: "hover",
                    id: 'our-services-prev',
                    children: /*#__PURE__*/_jsx(HiArrowSmallLeft, {})
                  }), /*#__PURE__*/_jsx("li", {
                    className: "hover",
                    id: 'our-services-next',
                    children: /*#__PURE__*/_jsx(HiArrowSmallRight, {})
                  })]
                })
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx(VisibilitySensor, {
      offset: {
        top: -150
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: " fade-up blog-slider__slider-wrap",
        children: [/*#__PURE__*/_jsx("div", {
          className: "blog-slider__slider-wrap__inner",
          children: Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 0 && /*#__PURE__*/_jsx(Swiper, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            speed: "1500",
            keyboardControl: true,
            modules: [Autoplay, Pagination, Navigation, Mousewheel],
            navigation: {
              prevEl: '#our-services-prev',
              nextEl: '#our-services-next'
            },
            onSlideChange: handleSlideChange,
            pagination: {
              type: 'fraction'
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            },
            ref: sliderRef,
            className: "mySwiper",
            children: Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 0 && (Data === null || Data === void 0 ? void 0 : Data.map(function (e, index) {
              var _e$images, _e$images$list, _e$images$list$, _e$images2, _e$images2$list, _e$images2$list$, _e$category, _e$category$category_, _e$category2, _e$category2$category;

              return /*#__PURE__*/_jsx(SwiperSlide, {
                children: /*#__PURE__*/_jsx("div", {
                  className: 'blog-single-single-wrp',
                  children: /*#__PURE__*/_jsx("div", {
                    className: "blog-single ",
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "blog-single__inner",
                      children: [(e === null || e === void 0 ? void 0 : e.data.slug) && /*#__PURE__*/_jsx(Link, {
                        href: "/blog/".concat(e === null || e === void 0 ? void 0 : e.data.slug)
                      }), /*#__PURE__*/_jsx(Img, {
                        alt: 'Shanta Securities Limited',
                        src: e !== null && e !== void 0 && (_e$images = e.images) !== null && _e$images !== void 0 && (_e$images$list = _e$images.list) !== null && _e$images$list !== void 0 && (_e$images$list$ = _e$images$list[0]) !== null && _e$images$list$ !== void 0 && _e$images$list$.full_path ? e === null || e === void 0 ? void 0 : (_e$images2 = e.images) === null || _e$images2 === void 0 ? void 0 : (_e$images2$list = _e$images2.list) === null || _e$images2$list === void 0 ? void 0 : (_e$images2$list$ = _e$images2$list[0]) === null || _e$images2$list$ === void 0 ? void 0 : _e$images2$list$.full_path : '/images/dynamic/career/c1.svg',
                        objectFit: 'cover',
                        layout: 'fill'
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "blog-single__inner__content",
                        children: [/*#__PURE__*/_jsxs("div", {
                          className: "blog-single__inner__content__top",
                          children: [/*#__PURE__*/_jsx("div", {
                            className: "hover-content"
                          }), (e === null || e === void 0 ? void 0 : e.data.title) && /*#__PURE__*/_jsx("h2", {
                            children: e === null || e === void 0 ? void 0 : e.data.title
                          })]
                        }), /*#__PURE__*/_jsx("div", {
                          className: "blog-single__inner__content__bottom",
                          children: (e === null || e === void 0 ? void 0 : (_e$category = e.category) === null || _e$category === void 0 ? void 0 : (_e$category$category_ = _e$category.category_data) === null || _e$category$category_ === void 0 ? void 0 : _e$category$category_.title) && /*#__PURE__*/_jsx("h4", {
                            children: e === null || e === void 0 ? void 0 : (_e$category2 = e.category) === null || _e$category2 === void 0 ? void 0 : (_e$category2$category = _e$category2.category_data) === null || _e$category2$category === void 0 ? void 0 : _e$category2$category.title
                          })
                        })]
                      })]
                    })
                  })
                })
              }, index);
            }))
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "slider-nav-mobile",
          children: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              className: "hover",
              ref: mLeftRef,
              children: /*#__PURE__*/_jsx(HiArrowSmallLeft, {})
            }), /*#__PURE__*/_jsx("li", {
              className: "hover",
              ref: mRightRef,
              children: /*#__PURE__*/_jsx(HiArrowSmallRight, {})
            })]
          })
        })]
      })
    })]
  });
};

var StyledBlog = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "BoxSlider__StyledBlog",
  componentId: "sc-1tuy45g-0"
})(["position:relative;&:after{position:absolute;left:0;right:0;bottom:0;height:calc(50vh + 65px);z-index:0;background:#f2f2f2;content:'';}.swiper-button-disabled{opacity:0.5 !important;}.image-wrapper{position:absolute;left:0;right:0;bottom:0;height:50%;}.blog-button{display:flex;justify-content:space-between;margin-bottom:85px;align-items:center;.left,.d-flex{height:100%;}.slider-nav{ul{display:flex;}li{height:40px;width:40px;background-color:black;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}.swiper-button-next,.swiper-button-prev{position:absolute;height:40px;width:40px;top:0;bottom:0;margin:auto;z-index:99;background-color:red;}.swiper-button-next,.swiper-button-prev,.swiper-pagination{opacity:0;visibility:hidden;}.swiper-initialized{margin-left:", "px;padding-right:8%;}.slider-nav-mobile{display:none;}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single-single-wrp{}.load{.dc-btn{display:flex;align-items:center;justify-content:center;margin-top:50px;}}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;overflow:hidden;.global-image{img{transform:scale(1.01);transition:1s all ease;}}a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{content:'';height:100%;width:100%;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:16px;color:#FFFFFF;font-family:'Avenir';font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.global-image{img{transform:scale(1.06);}}.blog-single__inner__content__top{h2{}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}@media (max-width:767px){padding-bottom:120px !important;.mobile{display:block;}.desktop{display:none !important;}.blog-single__inner__content__top{p,h2{left:30px;right:30px;top:30px;}}.blog-single__inner__content__bottom h4,.blog-single__inner__content__bottom p{left:30px;right:30px;top:30px;}.swiper-initialized{margin-left:15px;padding-right:15px;}.blog-slider{&__slider-wrap{.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;flex-direction:column;align-items:flex-start;.slider-nav{}}.slider-nav-mobile{display:none;}}"], function (props) {
  return props.offset + 15;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_13__/* .title */ .TN);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (RandomSliderV1)));

/***/ }),

/***/ 41116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30653);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var HrPhilosophy = function HrPhilosophy(_ref) {
  var data = _ref.data;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledHr, {
    className: "hr-philosophy ",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "hr-philosophy__title",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          children: (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h4", {
            className: " fade-up",
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.short_desc)
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: " fade-up hr-philosophy__content",
        children: (section_data === null || section_data === void 0 ? void 0 : section_data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.description)
      })]
    })
  });
};

var StyledHr = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CareerText__StyledHr",
  componentId: "sc-1t2mvif-0"
})(["padding-top:80px;padding-bottom:200px;.hr-philosophy__title{margin-bottom:75px;h4{font-family:'Avenir';font-size:32px;line-height:44px;color:#3C3C3B;font-weight:500 !important;}}.hr-philosophy__content{h4{font-size:24px;font-weight:500;line-height:32px;color:#3C3C3B;font-family:'Avenir';margin-bottom:20px;}p{font-size:16px;font-weight:500;margin-bottom:20px;span{color:", ";}&:nth-last-child(1){margin-bottom:0;}}}@media (max-width:767px){padding-top:120px;padding-bottom:120px;.col-md-6{margin-bottom:40px;&:last-child{margin-bottom:0;}}.hr-philosophy__title{margin-bottom:40px;h4{font-size:28px;line-height:36px;font-weight:500;}}.hr-philosophy__content{.col-sm-6{min-width:100%;&:nth-of-type(1){margin-bottom:40px;}}}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_7__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["Z"] = (HrPhilosophy);

/***/ }),

/***/ 46600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97346);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36981);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68019);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22920);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93264);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(68312);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30653);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(25317);
/* harmony import */ var _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92495);
/* harmony import */ var _pages_api_redux_contact__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86221);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












 // import {apiEndPoints} from "../../api/network/apiEndPoints";
// import {postForm} from "../../api/redux/career";








var MyComponent = function MyComponent(_ref) {
  var _data$images, _data$images$list, _data$images$list$, _data$images2, _data$images2$list, _data$images2$list$, _data$section_data, _data$section_data2, _errors$name, _errors$email, _errors$phone;

  var data = _ref.data,
      popup = _ref.popup,
      bg = _ref.bg,
      des = _ref.des,
      padding = _ref.padding;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
  var formData = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.careerReducer;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      validPosition = _useState[0],
      setValidPosition = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('Attach CV'),
      uploadText = _useState2[0],
      setUploadText = _useState2[1];

  var DropdownOption = [{
    value: 'Front-end Developer',
    label: 'Front-end Developer'
  }, {
    value: 'WordPress Developer',
    label: 'WordPress Developer'
  }, {
    value: 'DevOps Developer',
    label: 'DevOps Developer'
  }];

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
    mode: "all"
  }),
      register = _useForm.register,
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isSubmitSuccessful = _useForm$formState.isSubmitSuccessful,
      reset = _useForm.reset;

  var store = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.career;
  }); //--- form submit

  var success = function success(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(e) {
      var _e$file;

      var api_services, formData, tl;
      return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api_services = _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__/* .ApiServices.SUBMITFORM */ .u.SUBMITFORM;
              formData = new FormData();
              formData.append('name', e === null || e === void 0 ? void 0 : e.name);
              formData.append('email', e === null || e === void 0 ? void 0 : e.email);
              formData.append('phone', e === null || e === void 0 ? void 0 : e.phone);
              formData.append('message', e === null || e === void 0 ? void 0 : e.message);
              formData.append('form_id', 'career-form');
              formData.append('file', e === null || e === void 0 ? void 0 : (_e$file = e.file) === null || _e$file === void 0 ? void 0 : _e$file[0]);
              formData.append('spam_protector', '');
              document.querySelector('.gph_upload').classList.remove('hide');
              setUploadText('Attach CV');
              tl = new gsap__WEBPACK_IMPORTED_MODULE_14__/* .TimelineLite */ .Vq();

              if (!(e.email !== '' && e.name !== '' && e.phone !== '')) {
                _context.next = 16;
                break;
              }

              _context.next = 15;
              return dispatch((0,_pages_api_redux_contact__WEBPACK_IMPORTED_MODULE_10__/* .postForm */ .Md)([api_services, formData]));

            case 15:
              reset();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!(store !== null && store !== void 0 && store.loading)) {
      if (isSubmitSuccessful) {
        success("Thank you for your message");
        reset();
      }
    }
  }, [isSubmitSuccessful, store]);
  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error("Fill out the correct inputs");
    }

    count = 0;
  }; // let count = 0;
  // const onError = (errors) => {
  //     Object.values(errors).forEach((error) => {
  //         count++;
  //     });
  //     if (count > 0) {
  //         toast.error('Fill out the correct inputs');
  //     }
  //     count = 0;
  // };
  // useEffect(() => {
  //     if (responseData && responseData?.error !== '') {
  //         error(responseData?.error?.message)
  //     }
  //     if (responseData && responseData?.success !== '') {
  //         success(responseData?.success)
  //         // gsap.registerPlugin(ScrollTrigger);
  //         // reset()
  //
  //         // ScrollTrigger.refresh();
  //     }
  //     reset()
  // }, [responseData])


  var handleDropdown = function handleDropdown(e) {
    // e.value;
    setValidPosition(e === null || e === void 0 ? void 0 : e.label);
  }; // handleUpload function


  function handleUpload(event) {
    var selectedFile = event.target.files[0];

    if (selectedFile) {
      var fileName = selectedFile.name;
      setUploadText(fileName);
      document.querySelector('.gph_upload').classList.add('hidden');
    }
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(StyledComponent, {
    bg: bg,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .ToastContainer */ .Ix, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      hideProgressBar: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "career_form  ".concat(padding ? padding : 'pb-200'),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          children: [popup ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: {
              span: 5
            },
            className: "popup popup_data",
            children: des && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(des)
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: {
              span: 5
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "image_wrapper",
              children: (data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : (_data$images$list = _data$images.list) === null || _data$images$list === void 0 ? void 0 : (_data$images$list$ = _data$images$list[0]) === null || _data$images$list$ === void 0 ? void 0 : _data$images$list$.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_4__/* .Img */ .E, {
                alt: 'Shanta Securities Limited',
                src: data === null || data === void 0 ? void 0 : (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : (_data$images2$list = _data$images2.list) === null || _data$images2$list === void 0 ? void 0 : (_data$images2$list$ = _data$images2$list[0]) === null || _data$images2$list$ === void 0 ? void 0 : _data$images2$list$.full_path
              })
            }), (data === null || data === void 0 ? void 0 : (_data$section_data = data.section_data) === null || _data$section_data === void 0 ? void 0 : _data$section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_7__["default"], {
              noanim: true,
              margin: '40px 0 0 0',
              text: data === null || data === void 0 ? void 0 : (_data$section_data2 = data.section_data) === null || _data$section_data2 === void 0 ? void 0 : _data$section_data2.short_desc
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            md: {
              span: 6,
              offset: 1
            },
            className: "formContact",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "form-wrapper-all",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                onSubmit: handleSubmit(onSubmit, onError),
                method: "post",
                enctype: "multipart/form-data",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("input", {
                    name: 'spam_protector',
                    type: "hidden"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("input", {
                    name: 'form_id',
                    value: 'career-form',
                    type: "hidden"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-md-12 pb-30",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                      className: errors !== null && errors !== void 0 && (_errors$name = errors.name) !== null && _errors$name !== void 0 && _errors$name.message ? 'has-error form-control-lg' : 'form-control-lg'
                    }, register("name", {
                      required: 'Name is required',
                      pattern: {
                        message: 'Name must contain only letters'
                      }
                    })), {}, {
                      type: "text",
                      placeholder: "First Name*"
                    }))
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-md-12 pb-30",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                      className: errors !== null && errors !== void 0 && (_errors$email = errors.email) !== null && _errors$email !== void 0 && _errors$email.message ? 'has-error form-control-lg' : 'form-control-lg'
                    }, register("email", {
                      required: {
                        value: true,
                        message: 'Email is required'
                      },
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Enter a Valid Email'
                      }
                    })), {}, {
                      type: "email",
                      placeholder: "Email*"
                    }))
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-md-12 pb-30",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                      className: errors !== null && errors !== void 0 && (_errors$phone = errors.phone) !== null && _errors$phone !== void 0 && _errors$phone.message ? 'has-error form-control-lg' : 'form-control-lg'
                    }, register("phone", {
                      required: {
                        value: true,
                        message: 'Phone is required'
                      },
                      pattern: {
                        value: /^01[0-9]{9}$/,
                        message: 'Enter a valid 11 digit phone number'
                      }
                    })), {}, {
                      type: "number",
                      placeholder: "Phone Number*"
                    }))
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "clear"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-md-12 pb-30",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                      className: 'form-control-lg'
                    }, register("message", {
                      required: {
                        // value:true,
                        message: 'Message is Required'
                      }
                    })), {}, {
                      type: "text",
                      placeholder: "Cover Letter"
                    }))
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-xl-6 pb-30",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, _objectSpread({
                      onInput: handleUpload,
                      className: 'gph_upload',
                      text: uploadText,
                      type: "file",
                      accept: ".pdf"
                    }, register('file')))
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Group */ .Z.Group, {
                    className: "col-xl-6 widthHalf",
                    onClick: handleSubmit(onSubmit, onError),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                      padding: '0',
                      color: 'white',
                      hoverColor: '#3C3C3B',
                      hoverBackground: '#FFFFFF',
                      width: 'auto',
                      text: 'Submit Application',
                      classname: 'col-md-6'
                    })
                  })]
                })
              })
            })
          })]
        })
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Forms__StyledComponent",
  componentId: "sc-ewuvzi-0"
})(["background:", ";.image_wrapper{position:relative;padding-top:calc(244 / 500 * 100%);}.dc-btn a{&:hover{color:white !important;}}.form-wrapper-all{background:#3c3c3b;padding:60px 70px;@media (max-width:992px){padding:60px 30px;}@media (max-width:767px){padding:60px 15px;}}.form-control{margin-bottom:30px;background:transparent;border-left:none;border-right:none;border-top:none;border-bottom:1px solid rgba(255,255,255,0.5);}.dc-btn{width:100%;a{justify-content:center !important;}}.formContact{label{font-size:12px;line-height:18px;font-weight:300;}input{&:not(.react-select__input input){line-height:20px;border-radius:0;height:44px;border-color:rgba(255,255,255,0.5);}padding-left:0;padding-right:0;font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;&::placeholder{font-size:16px;font-weight:500;line-height:24px;color:rgba(255,255,255,0.5);}}.react-select__menu{z-index:9;}.react-select__control--menu-is-open{}.react-select__indicators{display:block;.react-select__indicator{padding-right:0;padding-left:0;color:white !important;}}.react-select__value-container{padding:0;display:block;}.react-select__single-value{font-size:16px;font-weight:500;line-height:24px;color:rgba(255,255,255,1);}textarea{border-radius:0;font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;padding-left:0;padding-right:0;border-color:rgba(255,255,255,0.5);&::placeholder{font-size:16px;font-weight:500;line-height:24px;color:rgba(255,255,255,0.5);}}.form-select{.react-select__indicator-separator{display:none;}.react-select__control{border-color:rgba(255,255,255,0.5);box-shadow:none;border-left:none;border-top:none;border-right:none;background:transparent;height:30px;margin-bottom:40px;}.react-select__placeholder{font-size:16px;font-weight:500;line-height:24px;color:rgba(255,255,255,0.5);}}.dc-btn{a{justify-content:center;span{}svg{}}}}.max_size{font-size:10px;font-weight:300;line-height:20px;color:rgba(34,34,34,0.8);margin:5px 0 0;}.gph_upload{position:relative;cursor:pointer;border:none !important;border-radius:25px !important;overflow:hidden !important;&.hidden{&:before{opacity:0;}}&:after{position:absolute;left:0;right:0;bottom:0;top:0;content:attr(text);border:1px #FFFFFF;border-radius:25px;border-style:dashed;background:#3C3C3B;z-index:1;font-size:16px;line-height:24px;font-weight:500;color:#FFFFFF;display:flex;align-items:center;justify-content:center;transition:0.7s all ease;padding-left:20px;}&:before{content:'';background-image:url('images/static/attach.svg');width:20px;height:20px;background-repeat:no-repeat;background-size:contain;position:absolute;z-index:11;left:25%;top:10px;}@media (min-width:1024px) and (max-width:1280px){&:after{padding-left:20px;}&:before{left:23%;}}@media (min-width:1536px){&:before{left:30%;}}&:hover{&:after{border:1px ", ";border-radius:25px;background:", ";}}}.has-error{border-color:#EE1B24 !important;}@media (min-width:1550px){.widthHalf{flex:0 0 50%;max-width:50%;}}input:-webkit-autofill{-webkit-text-fill-color:#fff;}"], function (props) {
  return props.bg ? props.bg : '#f2f2f2';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_20__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_20__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["Z"] = (MyComponent);

/***/ }),

/***/ 99801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Job; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 24 modules
var Modal = __webpack_require__(82307);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/simplebar-react.esm.js + 1 modules
var simplebar_react_esm = __webpack_require__(14863);
// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/simplebar.min.css
var simplebar_min = __webpack_require__(202);
// EXTERNAL MODULE: ./components/Title.jsx
var Title = __webpack_require__(93264);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./components/career/Forms.jsx
var Forms = __webpack_require__(46600);
// EXTERNAL MODULE: ./node_modules/gsap/gsap-core.js
var gsap_core = __webpack_require__(25317);
// EXTERNAL MODULE: ./pages/api/network/ApiServices.js
var ApiServices = __webpack_require__(92495);
// EXTERNAL MODULE: ./pages/api/redux/contact/index.js
var contact = __webpack_require__(86221);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/career/FeedbackForm.jsx

















var PopupV1 = function PopupV1(_ref) {
  var _popupId$data, _popupId$data2, _popupId$data3;

  var popupId = _ref.popupId,
      show = _ref.show,
      handleClose = _ref.handleClose,
      item = _ref.item,
      data = _ref.data;

  var _useState = (0,react.useState)(true),
      winWidth = _useState[0],
      setWinWidth = _useState[1];

  (0,react.useEffect)(function () {
    if (window.innerWidth > 767) {
      setWinWidth(true);
    } else {
      setWinWidth(false);
    }

    window.addEventListener("resize", function () {
      if (window.innerWidth > 767) {
        setWinWidth(true);
      } else {
        setWinWidth(false);
      }
    });
  }, []);
  var dispatch = (0,es/* useDispatch */.I0)();
  var responseData = (0,es/* useSelector */.v9)(function (state) {
    return state.contact;
  });

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset; //--- form submit


  var success = function success(msg) {
    return react_toastify_esm/* toast.success */.Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify_esm/* toast.error */.Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var handleBlur = function handleBlur() {// Perform onBlur logic here
  };

  var handleChange = function handleChange() {// Perform onChange logic here
  };

  var tl = new gsap_core/* TimelineLite */.Vq();

  var onSubmit = function onSubmit(e) {
    var api_services = ApiServices/* ApiServices.SUBMITFORM */.u.SUBMITFORM;
    var formData = new FormData();
    formData.append('name', e === null || e === void 0 ? void 0 : e.name);
    formData.append('email', e === null || e === void 0 ? void 0 : e.email);
    formData.append('phone', e === null || e === void 0 ? void 0 : e.phone);
    formData.append('message', e === null || e === void 0 ? void 0 : e.message);
    formData.append('form_id', 'feedback-form');
    formData.append('spam_protector', '');

    if (e.email !== '' && e.name !== '' && e.phone !== '') {
      dispatch((0,contact/* postForm */.Md)([api_services, formData])); // success('Successfully Submitted')

      tl.to('#smooth-content', {
        opacity: 1,
        duration: 0.1
      });
      reset();
      tl.to('#smooth-content', {
        opacity: 1,
        duration: 0.1
      });
      reset();
    }
  };

  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify_esm/* toast.error */.Am.error('Fill out the correct inputs');
    }

    count = 0;
  };

  (0,react.useEffect)(function () {
    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.error) !== '') {
      var _responseData$error;

      error(responseData === null || responseData === void 0 ? void 0 : (_responseData$error = responseData.error) === null || _responseData$error === void 0 ? void 0 : _responseData$error.message);
    } else if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.success) !== '') {
      var _responseData$success;

      success(responseData === null || responseData === void 0 ? void 0 : (_responseData$success = responseData.success) === null || _responseData$success === void 0 ? void 0 : _responseData$success.message);
    }

    reset();
  }, [responseData]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledModal, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: show,
      item: item,
      onHide: handleClose,
      backdrop: "static",
      keyboard: false,
      className: "gph_modal career_feedback_form popup-version-one investor_popup",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(simplebar_react_esm/* default */.Z, {
        className: "main_scroll",
        style: {
          height: '100vh'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
              className: 'for-close',
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 12,
                children: (popupId === null || popupId === void 0 ? void 0 : (_popupId$data = popupId.data) === null || _popupId$data === void 0 ? void 0 : _popupId$data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(Title["default"], {
                  margin: '0 0  0',
                  text: popupId === null || popupId === void 0 ? void 0 : (_popupId$data2 = popupId.data) === null || _popupId$data2 === void 0 ? void 0 : _popupId$data2.title
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: handleClose,
                className: "modal-close ",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                  id: "Button_-_Close",
                  "data-name": "Button - Close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "44",
                  height: "44",
                  viewBox: "0 0 44 44",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Ellipse_18",
                    "data-name": "Ellipse 18",
                    fill: "none",
                    stroke: "#3c3c3b",
                    "stroke-width": "1",
                    opacity: "0.3",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Ellipse_19",
                    "data-name": "Ellipse 19",
                    fill: "none",
                    stroke: "#3c3c3b",
                    "stroke-width": "1",
                    strokeDasharray: "0 142",
                    opacity: '0',
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                    id: "Group_18979",
                    "data-name": "Group 18979",
                    transform: "translate(-3149 -104.5)",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("line", {
                      id: "Line_4",
                      "data-name": "Line 4",
                      x2: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      "stroke-width": "1"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("line", {
                      id: "Line_3877",
                      "data-name": "Line 3877",
                      x1: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      "stroke-width": "1"
                    })]
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "modal-data d-flex",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  sm: {
                    span: 12
                  },
                  className: "modal-data__content",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "scroll-div",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(simplebar_react_esm/* default */.Z, {
                      autoHide: true,
                      style: {
                        maxHeight: 'calc(100vh - 100px)'
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Forms/* default */.Z, {
                          bg: '#FFF',
                          des: popupId === null || popupId === void 0 ? void 0 : (_popupId$data3 = popupId.data) === null || _popupId$data3 === void 0 ? void 0 : _popupId$data3.overview,
                          popup: true
                        })
                      })
                    })
                  })
                })
              })
            })
          })]
        })
      })
    })
  });
};

var StyledModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FeedbackForm__StyledModal",
  componentId: "sc-led930-0"
})([".modal-dialog{margin:0;}h4{letter-spacing:1.5px;}"]);
/* harmony default export */ var FeedbackForm = (PopupV1);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./components/Button.jsx
var Button = __webpack_require__(36981);
// EXTERNAL MODULE: ./styles/globalStyleVars.js
var globalStyleVars = __webpack_require__(68312);
;// CONCATENATED MODULE: ./components/career/Job.jsx











var HrPhilosophy = function HrPhilosophy(_ref) {
  var theData = _ref.theData,
      popup = _ref.popup,
      padding = _ref.padding;
  var joblist = theData;

  var _useState = (0,react.useState)(),
      popupId = _useState[0],
      setPopupId = _useState[1];

  var _useState2 = (0,react.useState)(false),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow(e) {
    setShow(true);
    setPopupId(e);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHr, {
    className: "job ".concat(padding ? padding : 'pb-200 pt-200'),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: "",
        children: [popup ? '' : /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          md: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title["default"], {
            noanim: true,
            margin: '0 0 75px 0',
            text: 'Take the right step with <span>Shanta Securities Limited</span>'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          md: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "list",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackForm, {
              popupId: popupId,
              show: show,
              handleClose: handleClose
            }), joblist && (joblist === null || joblist === void 0 ? void 0 : joblist.length) > 0 ? joblist === null || joblist === void 0 ? void 0 : joblist.map(function (e, index) {
              var _e$data, _e$data2, _e$data3, _e$data4;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "single-item",
                children: [(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                  className: 'font-weight-bold',
                  children: e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "time",
                  children: (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.overview) && (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.overview)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "button",
                  onClick: function onClick() {
                    return handleShow(e);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    newtablink: 'javascript:void(0)',
                    width: '180px',
                    text: 'View Details',
                    color: '#fff',
                    hoverBackground: '#3C3C3B',
                    background: '#978C21'
                  })
                })]
              }, index);
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                children: "No Job Available"
              })
            })]
          })
        })]
      })
    })
  });
};

var StyledHr = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Job__StyledHr",
  componentId: "sc-mnaiv1-0"
})(["background:#F2F2F2;.list{.single-item{display:flex;justify-content:space-between;padding-bottom:40px;margin-bottom:40px;border-bottom:1px solid rgba(198,198,198,0.5);&:last-child{margin-bottom:0;border-bottom:none;}h4{font-family:", ";font-size:20px;font-weight:300;line-height:28px;width:40%;}.time{width:30%;p{margin-bottom:8px;&:last-child{margin-bottom:0;}}}.button{}}@media(max-width:992px){.single-item{display:flex;flex-direction:column;justify-content:space-between;padding-bottom:40px;margin-bottom:40px;&:last-child{margin-bottom:0;}h4{margin-bottom:20px;width:100%;}.time{width:100%;p{margin-bottom:8px;&:last-child{margin-bottom:0;}}}.button{margin-top:20px;}}}}"], globalStyleVars/* title */.TN);
/* harmony default export */ var Job = (HrPhilosophy);

/***/ }),

/***/ 8711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98508);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var InnerbannerV9 = function InnerbannerV9(_ref) {
  var full = _ref.full,
      title = _ref.title,
      text = _ref.text,
      project = _ref.project,
      id = _ref.id,
      src = _ref.src,
      vh = _ref.vh,
      data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledInnerBanner, {
    id: "".concat(id ? id : 'InnerBanner'),
    full: full,
    vh: vh,
    className: "InnerBanner ".concat(project ? 'project_banner' : ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "InnerBanner__parallax",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "blur_image parallax",
        children: [src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_0__/* .Img */ .E, {
          src: src,
          alt: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
              className: "flex_box ",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 7,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "title",
                  children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(title)
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 5,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "text",
                  children: text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(text)
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var StyledInnerBanner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "innerbanner-v9__StyledInnerBanner",
  componentId: "sc-1lkjrda-0"
})(["position:relative;.InnerBanner__parallax{padding-top:", ";position:relative;@media (min-width:1550px){padding-top:", ";}@media (max-width:767px){padding-top:", ";}.flex_box{display:flex;justify-content:space-between;align-items:flex-end;width:100%;@media (max-width:767px){flex-direction:column;text-align:left;align-items:flex-start;}.text{position:relative;z-index:2;display:flex;justify-content:flex-end;@media (max-width:767px){display:block;justify-content:unset;}p{font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;@media (max-width:767px){text-align:left;br{}}}}}.blur_image{width:100%;height:100%;position:absolute;left:0;right:0;bottom:0;}.container{position:absolute;margin:0 auto;z-index:2;bottom:100px;left:0;right:0;@media (max-width:767px){bottom:40px;}h1{z-index:2;font-size:44px;line-height:56px;letter-spacing:-1px;margin:30px 0 0;font-weight:500;color:#FFFFFF;font-family:'Avenir';@media (max-width:767px){font-size:36px;line-height:42px;margin-bottom:15px;}}}}@media (min-width:1550px){}@media (max-width:767px){.InnerBanner__parallax{padding-top:", ";.container{bottom:40px;h1{font-size:40px;line-height:40px;margin:0px 0 20px;}}.flex_box{flex-direction:column;text-align:left;align-items:flex-start;.title{width:100%;}.text{display:block;justify-content:unset;p{width:100%;text-align:left;br{}}}}}}"], function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 375 * 100%)';
}, function (props) {
  return props.full ? '100vh' : '70vh';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(InnerbannerV9));

/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ })

}]);